import { loadJS } from './general';

export const init = () => { // eslint-disable-line import/prefer-default-export
  loadVideoAPI();
  setupVideos();
};

const loadVideoAPI = () => {
  const vimeoVideos = [...document.querySelectorAll('[data-video="Vimeo"]')];
  const youtubeVideos = [...document.querySelectorAll('[data-video="YouTube"]')];

  if (vimeoVideos.length) {
    loadJS('https://player.vimeo.com/api/player.js');
  }

  if (youtubeVideos.length) {
    loadJS('https://www.youtube.com/iframe_api');
  }
};

const setupVideos = () => {
  const videos = [...document.querySelectorAll('[data-video="Vimeo"],[data-video="YouTube"]')];

  videos.forEach((video) => {
    const videoId = video.dataset.videoId;
    const videoProvider = video.dataset.video.toLowerCase();

    const playButton = document.createElement('div');
    playButton.className = 'vt__play-video';
    playButton.setAttribute('data-video', videoProvider);
    playButton.setAttribute('data-video-id', videoId);

    const modalVideo = document.createElement('div');
    modalVideo.className = 'vt__modal-video';
    modalVideo.innerHTML = `
      <div class="vt__modal-video__wrapper">
        <div class="vt__modal-video__video">
          <div id="${videoProvider}-${videoId}"></div>
        </div>
        <div class="vt__modal-video__close" data-video="${videoProvider}" data-video-id="${videoId}"></div>
      </div>
    `;

    video.appendChild(playButton);
    document.body.appendChild(modalVideo);
  });

  addPlayButtonEvents();
  addCloseModalEvents();
};

const addPlayButtonEvents = () => {
  const playButtons = [...document.getElementsByClassName('vt__play-video')];
  playButtons.forEach((button) => {
    ['touchstart', 'click'].forEach(event => button.addEventListener(event, handlePlayVideo, false));
  });
};

const handlePlayVideo = (event) => {
  const videoProvider = event.target.dataset.video.toLowerCase();
  const videoId = event.target.dataset.videoId;

  switch (videoProvider) {
    case 'vimeo':
      triggerVimeoVideo(videoId);
      break;
    case 'youtube':
      triggerYoutubeVideo(videoId);
      break;
    default:
      break;
  }

  const modalVideo = document.getElementById(`${videoProvider}-${videoId}`);
  modalVideo.parentElement.parentElement.parentElement.classList.add('vt__modal-video--visible');
};

const addCloseModalEvents = () => {
  const closeModalVideoButtons = [...document.getElementsByClassName('vt__modal-video__close')];
  closeModalVideoButtons.forEach((button) => {
    ['touchstart', 'click'].forEach(event => button.addEventListener(event, handleCloseVideo, false));
  });
};

const handleCloseVideo = (event) => {
  const videoProvider = event.target.dataset.video.toLowerCase();
  const videoId = event.target.dataset.videoId;
  const player = window[`${videoProvider}Videos`][videoId];

  switch (videoProvider) {
    case 'vimeo':
      player.pause();
      break;
    case 'youtube':
      player.pauseVideo();
      break;
    default:
      break;
  }

  event.target.parentElement.parentElement.classList.remove('vt__modal-video--visible');
};

const triggerYoutubeVideo = (videoId) => {
  const youtubeVideos = window.youtubeVideos || {};
  if (youtubeVideos && youtubeVideos[videoId]) {
    youtubeVideos[videoId].playVideo();
    return youtubeVideos[videoId];
  }

  const player = new window.YT.Player(`youtube-${videoId}`, {
    videoId,
    width: 1280,
    height: 720,
    playerVars: {
      cc_load_policy: 0,
      showinfo: 0,
      modestbranding: 1,
      iv_load_policy: 3,
      autoplay: 1,
      rel: 0,
    },
  });

  player.addEventListener('onReady', () => {
    player.playVideo();
  });

  youtubeVideos[videoId] = player;
  window.youtubeVideos = youtubeVideos;

  return player;
};

const triggerVimeoVideo = (videoId) => {
  const vimeoVideos = window.vimeoVideos || {};
  if (vimeoVideos && vimeoVideos[videoId]) {
    vimeoVideos[videoId].play();
    return vimeoVideos[videoId];
  }

  const options = {
    id: videoId,
    width: 1280,
  };

  const player = new window.Vimeo.Player(`vimeo-${videoId}`, options);
  player.play();
  vimeoVideos[videoId] = player;
  window.vimeoVideos = vimeoVideos;

  return player;
  // player.pause();
};



// WEBPACK FOOTER //
// ./src/assets/js/video.js